"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import ExceptionItem from "./document_exception_item";
import ReactUtils from "../../react_utils";
import ExceptionSender from "../exception_sender";
import Api from "../../api/api";
import Auth from "../../util/auth";
import LoadEmailCreator from "../load_email_creator";
import OutgoingEmailSignature from "../../helpers/outgoing_email_signature";
import NewException, { DOCUMENTS_CONTEXT } from "./new_exception";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import { Flash } from "../../components/flash";
var bem = ReactUtils.makeBem("document_exception_area");
function ignoredMessage(props) {
  if (props.documentGroup.ignored) {
    return /* @__PURE__ */ jsx("div", { className: "alert-box--caution", children: "This group is ignored" });
  }
}
function continueProcessing(props) {
  props.closeExceptions();
}
function renderEmailTemplate(props, subjectTemplate, bodyTemplate) {
  var _a;
  const invoiceForTemplate = {
    exception_events: props.exceptions || [],
    failure_messages: []
  };
  return new LoadEmailCreator(
    props.selectedLoad,
    invoiceForTemplate,
    Auth._currentUser,
    subjectTemplate,
    bodyTemplate,
    ((_a = Api.Account.current()) == null ? void 0 : _a.payables_template_variables) || [],
    props.carrier,
    { blankMissing: true }
  ).initialEmail();
}
function emailProps(props, settings) {
  var _a;
  if (!settings.prefill_document_group_exception_emails) {
    return {
      defaultEmail: { body: OutgoingEmailSignature.signatureWithBuffer() }
    };
  }
  return {
    defaultEmail: renderEmailTemplate(
      props,
      settings.custom_exception_email_subject_template,
      settings.custom_exception_email_body_template
    ),
    renderTemplate: (subject, body) => renderEmailTemplate(props, subject, body),
    possibleLoad: props.selectedLoad,
    multipleExceptionMessagesEnabled: settings.multiple_custom_exception_templates,
    customEmailTemplates: settings.custom_exception_email_templates,
    templateVariables: (_a = Api.Account.current()) == null ? void 0 : _a.payables_template_variables
  };
}
function possibleDashboardOrNextGroupButton(props, state) {
  if (props.hasMore) {
    var buttonText = "Go To Next Group";
  } else {
    var buttonText = "Return To Dashboard";
  }
  if (state.messageSent && !state.sendingEmail) {
    return /* @__PURE__ */ jsxs("div", { className: bem("__dashboard-or-next-group-button-container"), children: [
      /* @__PURE__ */ jsx("span", { className: "button__cancel-wrapper-or", children: "or" }),
      /* @__PURE__ */ jsx(
        "button",
        {
          className: bem("__dashboard-or-next-group-button") + " button--progress",
          onClick: () => toDashboardOrNextGroup(props),
          children: buttonText
        }
      )
    ] });
  }
}
function toDashboardOrNextGroup(props) {
  var _a;
  if (props.hasMore) {
    (_a = props.documentsExceptionAddedCallback) == null ? void 0 : _a.call(props);
  } else {
    ToDashboardWithFilters(props.location);
  }
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { saving: false });
    // STATE
    __publicField(this, "startSendingEmail", () => {
      this.setState({
        sendingEmail: true,
        ignored: this.props.documentGroup.ignored
      });
    });
    __publicField(this, "cancelSendingEmail", () => {
      this.props.scrollUp();
      this.setState({ sendingEmail: false });
    });
    __publicField(this, "sendComplete", () => {
      this.props.scrollUp();
      this.setState({ sendingEmail: false, messageSent: true });
    });
    __publicField(this, "addResolutionMessageOption", () => {
      if (this.state.recentlyResolved && !this.state.addingResolutionMessage) {
        return /* @__PURE__ */ jsxs("div", { className: "document-exception-area-resolution-message-options", children: [
          /* @__PURE__ */ jsx("h4", { children: " The exception has been removed. " }),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: "button--secondary",
              onClick: this.startAddingResolutionMessage,
              children: "Add Resolution Message"
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: bem("__continue-processing-button") + " button--progress",
              onClick: () => continueProcessing(this.props),
              children: "Continue Processing"
            }
          )
        ] });
      }
    });
    __publicField(this, "startAddingResolutionMessage", () => {
      this.setState({ addingResolutionMessage: true });
    });
    __publicField(this, "saveResolutionMessageButton", () => {
      return /* @__PURE__ */ jsx("button", { className: "button--progress", onClick: this.saveResolutionMessage, children: "Save" });
    });
    __publicField(this, "saveResolutionMessage", () => {
      this.setState({ saving: true });
      this.props.exceptionUpdater(
        this.state.resolutionMessage,
        // Only reachable after recentlyResolved has stored the exception.
        this.state.exception,
        this.props.documentGroup
      ).then(() => {
        Flash.success("The resolution message was added!");
        this.props.closeExceptions();
      });
    });
    __publicField(this, "addResolutionMessageDialogue", () => {
      if (this.state.addingResolutionMessage) {
        return /* @__PURE__ */ jsxs("div", { className: "rules__resolve-exception-container", children: [
          /* @__PURE__ */ jsx(
            "textarea",
            {
              placeholder: "Resolution Message",
              rows: 4,
              value: this.state.resolutionMessage || "",
              onChange: (e) => this.setState({
                resolutionMessage: e.target.value
              })
            }
          ),
          this.saveResolutionMessageButton(),
          /* @__PURE__ */ jsxs("span", { className: "button__cancel-wrapper", children: [
            " ",
            /* @__PURE__ */ jsx("span", { className: "button__cancel-wrapper-or", children: "or" }),
            /* @__PURE__ */ jsx(
              "button",
              {
                className: "button--cancel",
                onClick: this.cancelAddingResolutionmessage,
                children: "cancel"
              }
            )
          ] })
        ] });
      }
    });
    __publicField(this, "cancelAddingResolutionmessage", () => {
      this.setState({ addingResolutionMessage: false });
    });
    __publicField(this, "recentlyResolved", (exception) => {
      this.setState({ recentlyResolved: true, exception });
      this.props.recentlyResolved();
    });
    __publicField(this, "existingExceptionArea", (exception) => {
      if (this.state.recentlyResolved) {
        return /* @__PURE__ */ jsxs("div", { className: "document-exception-area-wrapper", children: [
          this.addResolutionMessageOption(),
          this.addResolutionMessageDialogue()
        ] });
      } else {
        return /* @__PURE__ */ jsxs("div", { className: "document-exception-area-wrapper", children: [
          ignoredMessage(this.props),
          /* @__PURE__ */ jsx("div", { className: "alert-box--caution", children: "The following exceptions were reported for this document group:" }),
          /* @__PURE__ */ jsx("ul", { className: "rules__list", children: /* @__PURE__ */ jsx(
            ExceptionItem,
            {
              exception,
              recentlyResolved: this.recentlyResolved,
              exceptionResolver: this.props.exceptionResolver,
              owner: this.props.documentGroup
            }
          ) }),
          /* @__PURE__ */ jsxs("div", { className: bem("__email-buttons"), children: [
            this.sendEmailButtonOrSender(exception),
            possibleDashboardOrNextGroupButton(this.props, this.state)
          ] })
        ] });
      }
    });
    __publicField(this, "sendEmailButtonOrSender", (exception) => {
      if (this.state.sendingEmail) {
        const settings = Api.Account.currentSettings() || {};
        return /* @__PURE__ */ jsx(
          ExceptionSender,
          __spreadProps(__spreadValues({
            documents: this.props.model.activeDocuments(),
            onComplete: this.sendComplete,
            ignored: this.state.ignored,
            messageSent: this.state.messageSent,
            canCancel: true,
            cancel: this.cancelSendingEmail
          }, emailProps(this.props, settings)), {
            documentGroupId: this.props.documentGroup.id,
            parent: this.props.email,
            hasMore: this.props.hasMore,
            toDashboardOrNextGroup: () => toDashboardOrNextGroup(this.props),
            contacts: this.props.carrier.contacts
          })
        );
      } else {
        if (this.state.messageSent) {
          return /* @__PURE__ */ jsx(
            "button",
            {
              onClick: this.startSendingEmail,
              className: "button--secondary",
              children: "Message Sent. Send Another"
            }
          );
        } else {
          return /* @__PURE__ */ jsx(
            "button",
            {
              onClick: this.startSendingEmail,
              className: "button--confirmation",
              children: "Send Message"
            }
          );
        }
      }
    });
    __publicField(this, "newExceptionArea", () => {
      return /* @__PURE__ */ jsxs("div", { className: "document-exception-area-wrapper", children: [
        /* @__PURE__ */ jsx("div", { className: "alert-box--caution", children: "Create an exception for this document group: (ex. Unable to find load in TriumphPay Audit, Documents belong to a different broker)" }),
        /* @__PURE__ */ jsx(
          NewException,
          {
            exceptionCreator: this.props.exceptionCreator,
            context: DOCUMENTS_CONTEXT,
            documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
            startSendEmail: this.startSendingEmail,
            location: this.props.location,
            group: this.props.documentGroup,
            groups: this.props.model.groups,
            hasMore: this.props.hasMore,
            onCancel: this.props.onCancel
          }
        )
      ] });
    });
  }
  // RENDER
  render() {
    var exception = _.first(this.props.exceptions);
    if (this.state.recentlyResolved || exception) {
      return this.existingExceptionArea(exception);
    } else {
      return this.newExceptionArea();
    }
  }
}
